import { useLocation, useNavigate } from 'react-router-dom'
import styles from './ResetPassword.module.scss'
import { Card } from '@/ui/card'
import PlatformBranding from '../../components/PlatformBranding/PlatformBranding'
import DynamicForm from '../../components/DynamicForm/DynamicForm'
import { useUIConfig } from '../../hooks/useUIConfig'
import { toast } from 'sonner'
import FormHeading from '../../components/FormHeading/FormHeading'
import { useResetPassword } from '../../hooks/useResetPassword'

const resetPasswordFields = [
    {
        id: "password",
        label: "New Password",
        type: "password",
        placeholder: "Enter new password",
        required: true,
        isDisplay: true,
        validation: {
            minLength: 6,
            message: "Password must be at least 6 characters",
        },
    },
    {
        id: "confirmPassword",
        label: "Confirm Password",
        type: "password",
        placeholder: "Re-enter your password",
        required: true,
        isDisplay: true,
    },
]

const ResetPassword = () => {
    const { data: uiConfig, isLoading, error } = useUIConfig()
    const navigate = useNavigate()
    const location = useLocation()
    const resetPasswordMutation = useResetPassword()

    const resetToken = (location.state as any)?.resetToken || ''

    const handleSubmit = async (data: any) => {
        if (data.password !== data.confirmPassword) {
            toast.error('Passwords do not match')
            return
        }

        if (!resetToken) {
            toast.error('Missing reset token, please start password recovery again.')
            navigate('/forgot-password')
            return
        }

        try {
            await resetPasswordMutation.mutateAsync({
                new_password: data.password,
                reset_token: resetToken,
            })

            toast.success('Password has been reset successfully.')
            navigate('/')
        } catch (err: any) {
            toast.error(err?.message || 'An error occurred while resetting password.')
        }
    }

    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loader}>
                    <div className={styles.spinner}></div>
                    <p>Loading...</p>
                </div>
            </div>
        )
    }
    if (error) return <div>Error loading config</div>

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div className={styles.left}>
                    <PlatformBranding
                        logo={uiConfig?.data?.logo}
                        platformName={uiConfig?.data?.ui_config.platform_name}
                        slogan={uiConfig?.data?.ui_config.platform_slogan}
                    />
                </div>
                <div className={styles.right}>
                    <Card className={styles.form}>
                        <FormHeading
                            title="Reset Password"
                            subtitle="Enter your new password and confirm it to set a new password."
                            as="h1"
                            align="center"
                        />
                        <DynamicForm
                            fields={resetPasswordFields}
                            onSubmit={handleSubmit}
                            loading={false}
                            primaryAction={{ label: 'Reset Password' }}
                            options={{ showBackToLogin: true, loginLink: '/' }}
                        />
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;